module.exports = __webpack_public_path__ + "static/img/batch_icon.87afe326.png";